export function getRelativePath(url: string): string {
  try {
    const urlObj = new URL(url);
    return urlObj.pathname.substring(urlObj.pathname.lastIndexOf('/'));
  } catch (error) {
    console.error('Invalid URL');
    return url;
  }
}
